import { useState, useEffect } from 'react';
import dayjs from 'dayjs';

import AgentScript from 'components/AgentScript/AgentScript';

import { formatDate, isAfterCutOffTime } from 'utilities/datesAndTimes';

const PaymentAuthorizationMessage = ({
  account = '--',
  amount,
  cardLast4 = '--',
  date,
  isScheduledPayment,
}) => {
  const [paymentDate, setPaymentDate] = useState(null);
  const translateKey = isScheduledPayment
    ? 'scheduledPaymentScript'
    : 'oneTimePaymentScript';

  useEffect(() => {
    if (date) {
      let displayDate = dayjs(date);
      // If Immediate payment, check if past cutoff time to render the actual payment date
      if (!isScheduledPayment) {
        if (isAfterCutOffTime()) {
          displayDate = dayjs().add(1, 'day');
        } else {
          displayDate = dayjs();
        }
      }
      setPaymentDate(formatDate(displayDate));
    } else {
      setPaymentDate('--');
    }
  }, [date, isScheduledPayment]);

  return (
    <AgentScript
      title="Payment Authorization"
      translateKey={`payments.${translateKey}`}
      values={{
        account,
        amount: amount ? `$${amount}` : '--',
        cardLast4,
        paymentDate,
        todaysDate: formatDate(dayjs()),
      }}
    />
  );
};

export default PaymentAuthorizationMessage;
